<header></header>
<div class="post-login-2">
    <div class="post-login-2-col-1 h-100">
        <!-- <left-panel activeTab="2"></left-panel> -->
        <left-panel activeTab="2" *ngIf="this.auth?.detailuser != undefined && this.AccountType == 'C'"></left-panel>
    <left-panel activeTab="3" *ngIf="this.auth?.detailuser != undefined  && this.AccountType == 'L'"></left-panel>
  <!-- </div> -->
    </div>
    <div class="post-login-2-col-2 has-banner">
    </div>
    <div class="post-login-2-col-3 bg-base-100">
        <grid-row class="justify-content-center h-100">
            <grid-col col="10" mobile="12">
                <grid-row class="justify-content-between align-item-center mt-15">
                    <grid-col col="auto" mobile="12">
                        <grid-row class="col-space-min align-item-center">
                            <grid-col col="auto">
                                <div class="link" (click)="back()">
                                    <ng-icon iconClass="icon-arrow-left-black" width="22" height="22"></ng-icon>
                                </div>
                            </grid-col>
                            <grid-col col="auto">
                                <div class="font-500 font-size-20px letter-spacing-1 color-base-1700">
                                    {{this.commonP.StringToDateTwo(this.MonthYear)|date:"MMMM YYYY"}}
                                </div>
                            </grid-col>
                        </grid-row>
                    </grid-col>
                    <grid-col col="auto" mobile="12" class="mt-mobile-20">
                        <grid-row class="justify-content-between col-space-min">
                            <grid-col col="3" mobile="12">
                                <button class="btn-dft" (click)="this.showModal(1)"
                                    [disabled]="this.ViewStatementList && this.ViewStatementList.length==0?'disabled':''">
                                    {{"SendToEmail" | translate}}
                                </button>
                            </grid-col>
                            <!-- <grid-col col="3">
                                <div class="bg-base-100 br-12 p-16 box-shadow-5 link"
                                    *ngIf="this.ViewStatementList && this.ViewStatementList.length>0">
                                    <ng-icon iconClass="icon-download-new" width="24" height="24" (click)="DownloadStatement()"></ng-icon>
                                </div>
                                <div class="br-12 p-16 box-shadow-5 bg-base-100" *ngIf="this.ViewStatementList && this.ViewStatementList.length==0">
                                    <ng-icon iconClass="icon-download-new" width="24" height="24"></ng-icon>
                                </div>
                            </grid-col> -->
                        </grid-row>
                    </grid-col>
                </grid-row>
                <div *ngFor="let items of ViewStatementList" (click)="handleClick(items,2)">
                    <div class="font-400 font-size-14px color-base-1500 mb-5 mt-30">
                        {{ items?.label }}
                    </div>
                    <div class="bg-base-100 box-shadow border border-color-900 br-12 mb-15 pl-15 pr-15" *ngIf="this.ViewStatementList" >
                        <grid-row class="justify-content-between mb-10 mt-10" *ngFor="let item of items?.cardTransactions">
                            <grid-col col="auto">
                                <div class="font-400 font-size-12px line-h-20 color-base-1500">
                                    {{item?.transactionDescription}}
                                </div>
                                <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-left"
                                    *ngIf=" item?.transactionDate">
                                    {{item?.transactionDate }}
                                    <!-- |date:"hh:mm:a" -->
                                </div>
                            </grid-col>
                            <grid-col col="auto">
                                <div class="font-600 font-size-14px line-h-20 color-black" *ngIf="item?.debitCreditIndicator=='D'">
                                    - {{item?.transactionCurrency}} {{item?.transactionAmount |amountFormatter}}
                                </div>
                                <div class="font-600 font-size-14px line-h-20 color-success" *ngIf="item?.debitCreditIndicator=='C'">
                                    {{item?.transactionCurrency}} {{item?.transactionAmount |amountFormatter}}
                                </div>
                                <!-- <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-right">
                                            {{"GBP" | translate}} 140.71
                                        </div> -->
                            </grid-col>
                        </grid-row>
                    </div>
                </div>

                <!-- <div *ngFor="let items of ViewStatementList" (click)="handleClick(items, 2)">
                    <div 
                        class="font-400 font-size-14px color-base-1500 mb-5 mt-30"
                        
                    >
                        {{ items?.label }}
                    </div>
                    <div class="bg-base-100 box-shadow border border-color-900 br-12 mb-15 pl-15 pr-15">
                        <grid-row class="justify-content-between mb-10 mt-10" *ngFor="let item of items?.cardTransactions">
                            <grid-col col="auto" (click)="handleClick(item)">
                                <div class="font-400 font-size-12px line-h-20 color-base-1500">
                                    {{ item?.transactionDescription }}
                                </div>
                                <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-left" *ngIf="item?.transactionDate">
                                    {{ item?.transactionDate | date: "hh:mm:a" }}
                                </div>
                            </grid-col>
                            <grid-col col="auto" (click)="handleClick(item)">
                                <div
                                    class="font-600 font-size-14px line-h-20 color-black"
                                    *ngIf="item?.debitCreditIndicator == 'D'"
                                >
                                    - {{ item?.transactionCurrency }} {{ item?.transactionAmount | amountFormatter }}
                                </div>
                                <div
                                    class="font-600 font-size-14px line-h-20 color-success"
                                    *ngIf="item?.debitCreditIndicator == 'C'"
                                >
                                    {{ item?.transactionCurrency }} {{ item?.transactionAmount | amountFormatter }}
                                </div>
                            </grid-col>
                        </grid-row>
                    </div>
                </div> -->
                
                <!-- Empty State -->
                <grid-row class="justify-content-center align-item-center h-100" *ngIf="this.ViewStatementList?.length==0">
                    <grid-col col="5">
                        <div class="text-align-center">
                            <ng-icon iconClass="icon-creditcard-not-available" width="307" height="230"></ng-icon>
                        </div>
                
                        <div class="font-400 font-size-14px line-h-20 color-base-500 text-align-center mt-5">
                            {{"Thereisnoavailable" | translate }}
                        </div>
                    </grid-col>
                </grid-row>
            </grid-col>

        </grid-row>
    </div>
</div>

<!-- Send to email Modal -->
<modal modalID="1" [events]="modalObservable.asObservable()" [backdropDismiss]="true" modalDoneButtonText="CONFIRM"
    [modalDoneButtonDisabled]="isValidEmail()" (doneButton)="SendStatementToEmail()">
    <div>
        <div class="font-400 font-size-20px line-h-28 color-base-1300 mt-10 text-align-center">
            {{"PleaseEnterOrConfirmYourEmailAddress"| translate}}
        </div>
        <div class="form-group mt-50">
            <label class="no-mark">
                {{ "EmailAddress" | translate }}
            </label>
            <input type="email" placeholder="Please enter" [(ngModel)]="this.EmailIds">
        </div>
    </div>
</modal>



<!-- Transaction DETAILS Modal -->
<modal modalID="2" [events]="modalObservable.asObservable()" [backdropDismiss]="false"
modalDoneButtonText="Share Receipt"   >
    <!-- (doneButton)="DownloadStatementcard(selectedItem?.transactionDate)" -->
    <div class="text-align-center">
        <div class="font-400 font-size-14px line-h-20 color-base-1800">

            {{selectedItem?.transactionDescription}}

        </div>
        <div class="font-500 font-size-24px line-h-32 color-success"
            *ngIf="selectedItem?.debitCreditIndicator=='C'">
            {{"BHD" | translate}} {{selectedItem?.billingAmount}}
        </div>
        <div class="font-500 font-size-24px line-h-32 color-error"
            *ngIf="selectedItem?.debitCreditIndicator=='D'">
            - {{"BHD" | translate}} {{selectedItem?.billingAmount}}
        </div>
    </div>
    <div class="font-400 font-size-14px line-h-20 color-base-1800 mt-24 letter-spacing-1">
        {{"TransactionDetails" | translate}}
    </div>
    <grid-row class="justify-content-between mt-24">
        <!-- <grid-col col="auto">
        <div class="font-400 font-size-12px line-h-20 color-base-1800">
            {{"Balance" | translate}}
        </div>
    </grid-col>
    <grid-col col="auto">
        <div class="font-500 font-size-14px line-h-20 color-base-1300">
            {{"BHD" | translate}} 1,240.54
        </div>
    </grid-col> -->
    </grid-row>
    <grid-row class="justify-content-between mt-24">
        <grid-col col="auto">
            <div class="font-400 font-size-12px line-h-20 color-base-1800">
                {{"RefiD" | translate}}
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-500 font-size-14px line-h-20 color-base-1300">
                {{selectedItem?.referenceNumber}}
            </div>
        </grid-col>
    </grid-row>

    <grid-row class="justify-content-between mt-24">
        <grid-col col="auto">
            <div class="font-400 font-size-12px line-h-20 color-base-1800">
                {{"Date" | translate}}
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-500 font-size-14px line-h-20 color-base-1300"
                *ngIf="selectedItem?.transactionDate">
                {{ getDate(selectedItem?.transactionDate) }}
            </div>
        </grid-col>
    </grid-row>
    <grid-row class="justify-content-between mt-24">
        <grid-col col="auto">
            <div class="font-400 font-size-12px line-h-20 color-base-1800">
                {{"Time" | translate}}
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-500 font-size-14px line-h-20 color-base-1300">
                {{ getTime(selectedItem?.transactionDate) }}
            </div>
        </grid-col>
    </grid-row>
    
</modal>